import React from "react";

import { routes } from "../../utils/constants/constant";
import BreadCrumbComponent from "../../components/breadcrumb/BreadCrumbComponent";

import "./ContactUs.scss";

const breadCrumbs = [
  {
    name: "Trang chủ",
    isLink: true,
    link: routes.DASHBOARD,
  },
  {
    name: "Hỗ trợ",
    isLink: false,
  },
];

const ContactUs = () => {
  return (
    <div className="container-home">
      <BreadCrumbComponent breadCrumbs={breadCrumbs} />
      <div className="title-container-home">Hỗ trợ</div>
    </div>
  );
};

export default ContactUs;
